import { render, staticRenderFns } from "./VariantSifterTrackStrip.vue?vue&type=template&id=5ce49a25&scoped=true&"
import script from "./VariantSifterTrackStrip.vue?vue&type=script&lang=js&"
export * from "./VariantSifterTrackStrip.vue?vue&type=script&lang=js&"
import style0 from "./VariantSifterTrackStrip.vue?vue&type=style&index=0&id=5ce49a25&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce49a25",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ce49a25')) {
      api.createRecord('5ce49a25', component.options)
    } else {
      api.reload('5ce49a25', component.options)
    }
    module.hot.accept("./VariantSifterTrackStrip.vue?vue&type=template&id=5ce49a25&scoped=true&", function () {
      api.rerender('5ce49a25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/kpVariantSifter/VariantSifterTrackStrip.vue"
export default component.exports